import { CmsErrorPage } from '../../models/error/error-page.type';

export const mockCmsErrorPage: CmsErrorPage = {
  pageTitle: 'Error Page',
};
